import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import EquipmentForm from "../component/equipmentform";
import PartsInventory from "../component/Parts-Inventory";
import PartsDetailsInventory from "../component/PartsDetailsInventory";
import { dash, pictureUrls } from "../component/displayValue";
import "../component/css/listing-table.css";

const InventoryDetail = () => {
  const { state } = useLocation();
  // Accept either the raw record or the display props object used by older links.
  const loadedProduct = state?.equipmentData?.data || state?.equipmentData || null;
  const hasProduct = Boolean(loadedProduct);
  const product = loadedProduct || {};
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [largeImageLoaded, setLargeImageLoaded] = useState(false);
  const [smallImagesLoaded, setSmallImagesLoaded] = useState(false);

  const handleLargeImageLoad = () => {
    setLargeImageLoaded(true);
  };

  const handleSmallImageLoad = () => {
    setSmallImagesLoaded(true);
  };

  // const fetchData = async (page) => {
  //   try {
  //     setLoading(true);

  //     const response = await fetch(
  //       'part_inventory.php'
  //     );
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     const responseData = await response.json();
  //     console.log(response);
  //     console.log(responseData);
  //     if (responseData.error) {
  //       console.error("Error fetching data:", responseData.error);
  //     } else {
  //       setRelatedProducts(responseData.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  // useEffect(() => {
  //   fetchData(1);
  // }, []);

  console.log("This is the ==================== Product", product);


  const defaultImage = "";
  const images = pictureUrls(product);

  const hasImages = images.length > 0;

  const [selectedImage, setSelectedImage] = useState(
    hasImages ? images[0] || defaultImage : defaultImage
  );
  const [selectedThumbnail, setSelectedThumbnail] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [showInquiryModal, setShowInquiryModal] = useState(false);

  if (!hasProduct) {
    return (
      <>
        <TopHeader />
        <Secondheader />
        <div className="banner-image banner-image-part">
          <h1>Parts Inventory</h1>
        </div>
        <div className="no-result">
          <h1>No product details available</h1>
        </div>
      </>
    );
  }

  const values = {
    jad_id: product.JAD_ID,
    description: product.Product_Description,
    model: product.Model,
    vintage: product.Vintage,
    Inspection_Available: product.Inspection_Available,
    Condition: product.Condition,
    Manufacturer: product.Manufacturer_Id,
    thumb: defaultImage,
    Parts_number: product['Part Number'],
    Revision: product.Revision,
    productsList: product.Compartible_Parts

  };


  console.log("================================ Product Values ====================", values)

  const handleThumbnailClick = (largeImage, index) => {
    setSelectedImage(largeImage);
    setSelectedThumbnail(index);
  };
  const handleRightButtonClick = () => {
    if (startIndex < product.images - 4) {
      setStartIndex(startIndex + 1);
    }
  };

  const handleLeftButtonClick = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };
  const handleLargeImageChange = (direction) => {
    const newIndex =
      direction === "next" ? selectedThumbnail + 1 : selectedThumbnail - 1;

    if (newIndex >= 0 && newIndex < images.length) {
      setSelectedImage(images[newIndex] || defaultImage);
      setSelectedThumbnail(newIndex);
    }
  };

  const handleInquireButtonClick = () => {
    setShowInquiryModal(true);
  };

  const handleCloseInquiryModal = () => {
    setShowInquiryModal(false);
  };
  const smallImages = images;

  const hasSmallImages = smallImages.length > 0;

  const related_product_data_html =
    product.Compartible_Parts &&
    Array.isArray(product.Compartible_Parts) &&
    product.Compartible_Parts.length > 0 ? (
      product.Compartible_Parts.map((value, index) => (
        <PartsDetailsInventory
          key={value.JAD_ID || index}
          jad_id={value.JAD_ID}
          description={value.Product_Description}
          model={value.Model}
          Manufacturer={value.Manufacturer_Id}
          data={value}
          thumb={value.thumb}
          Inspection_Available={value.Is_Inspection_Available}
          vintage={value.Vintage}
          Condition={value.Condition}
          Parts_number={value["Part Number"]}
          Revision={value.Revision}
        />
      ))
    ) : (
      <tr>
        <td colSpan={6} className="listing-empty">
          No compatible parts recorded for this part.
        </td>
      </tr>
    );

  console.log("===========Related Products===============", relatedProducts)

  return (
    <>
      <TopHeader />
      <Secondheader />
      {hasImages && loading && !(largeImageLoaded && smallImagesLoaded) && (
        <div className="loading-bar"></div>
      )}

      <div className="banner-image banner-image-part">
        <h1>Parts Inventory</h1>
      </div>
      <div className="Product_details_container">
        <div className="Display_box_product">
          <div className="Product_img_Box">
            <h3>View Part</h3>

            {hasImages ? (
              <div className="detail-image-strip">
                {images.map((image, index) => (
                  <img key={index} src={image} alt={`Part view ${index + 1}`} />
                ))}
              </div>
            ) : (
              <div className="detail-image-placeholder">
                <span>No image available</span>
              </div>
            )}

            <div className="product-box-info">
              <h4>
                <span className="inventory-title">JAD-ID:</span>
                <span className="inventory-text"> {dash(product.JAD_ID)}</span>
              </h4>
              <h4>
                <span className="inventory-title">Manufacturer:</span>
                <span className="inventory-text">  {dash(product.Manufacturer_Id)} </span>
              </h4>

              <h4>
                <span className="inventory-title">Revision:</span>
                <span className="inventory-text"> {dash(product.Revision)} </span>
              </h4>

              <h4>
                <span className="inventory-title">Description:</span>
                <span className="inventory-text"> {dash(product.Product_Description)} </span>
              </h4>
              <h4>
                <span className="inventory-title">Part Number:</span>
                <span className="inventory-text"> {dash(product["Part Number"])} </span>
              </h4>
              <h4>
                <span className="inventory-title">Model:</span>
                <span className="inventory-text"> {dash(product.Model)} </span>
              </h4>
              <h4>
                <span className="inventory-title">Category:</span>
                <span className="inventory-text"> {dash(product.Category)} </span>
              </h4>
              <h4>
                <span className="inventory-title">Condition:</span>
                <span className="inventory-text"> {dash(product.Condition)} </span>
              </h4>
              <h4>
                <span className="inventory-title">Serial Number:</span>
                <span className="inventory-text"> {dash(product.Serial_Number)} </span>
              </h4>
              <h4>
                <span className="inventory-title">Status:</span>
                <span className="inventory-text"> {dash(product.Status)} </span>
              </h4>
            </div>
          </div>
          <div className="product_details_text inventory-detail">

            <button className="inquire-btn" onClick={handleInquireButtonClick}>
              INQUIRE
              <span style={{ marginLeft: "5px" }}>&rarr;</span>
            </button>

            <h4 className="comments-text">Comments</h4>
            <p className="comments-text-para"> {dash(product.Comments)} </p>
          </div>
        </div>
        <EquipmentForm
          showInquiryModal={showInquiryModal}
          handleCloseInquiryModal={handleCloseInquiryModal}
          values={values}
          producttype="inventory"
        />
        <div className="Manufacturer_box">
          <h1 className="more-parts-inventory">Compatible Parts</h1>
          <div className="listing-table-wrap">
            <table className="listing-table">
              <colgroup>
                <col style={{ width: "13%" }} />
                <col style={{ width: "29%" }} />
                <col style={{ width: "16%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "14%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Parts</th>
                  <th>Description</th>
                  <th>Manufacturer</th>
                  <th>Part Number</th>
                  <th>Revision</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{related_product_data_html}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default InventoryDetail;
